<template>
  <div>
    <app-template />
    <div class="uk-container uk-container-large">
      <template v-if="passwordUpDated !== true">
        <div v-if="notFount === true">
          <h2>Looks like you have entered an invalid URL.</h2>
          <p>
            The link is invalid/expired. Either you did not copy the correct
            link from the email, or you have already used the key in which case
            it is deactivated.
          </p>
        </div>
        <div v-else>
          <div class="intro-header">
            <div class="header-buttons">
              <h2>Password reset</h2>
            </div>
          </div>

          <div>
            <div>
              <p v-if="validationText !== ''" class="uk-text-danger">
                {{ validationText }}
              </p>

              <div class="form__item">
                <label class="form__label" for="password"
                  >Current Password</label
                >

                <input
                  class="form__input"
                  type="password"
                  v-model="oldPassword"
                  id="password"
                />
                <!--<p class="invalid-feedback" v-if="validationValues.password.state === true">{{ validationValues.password.text }}</p>-->
              </div>

              <div class="form__item">
                <label class="form__label" for="newPassword"
                  >New Password</label
                >
                <input
                  class="form__input"
                  type="password"
                  v-model="password"
                  id="newPassword"
                />
                <!--<p class="invalid-feedback" v-if="validationValues.password.state === true">{{ validationValues.password.text }}</p>-->
              </div>

              <button @click="resetPassword()" class="green-button">
                Reset password
              </button>
              <p>
                If you can't rememebr your old password, please contact support
                -
                <a href="mailTo:stewart@the-performace-centre.co.uk">Support</a>
              </p>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="intro-header">
          <div class="header-buttons">
            <h2>Password reset sucessfully</h2>
            <router-link :to="{ name: 'login' }"> Login </router-link>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import AppTemplate from "../layouts/App";
import { Mail } from "@/services/mail-service.js";
import {
  getAuth,
  updatePassword,
  signInWithEmailAndPassword,
} from "firebase/auth";

export default {
  name: "passwordRecover",
  components: { AppTemplate },
  data() {
    return {
      oldPassword: "",
      password: "",
      notFount: false,
      resetData: {},
      passwordUpDated: false,
      validationText: "",
    };
  },
  created() {
    this.checkURL();
  },
  methods: {
    checkURL() {
      if (
        Object.keys(this.$route.query).length === 0 ||
        this.$route.query.action === undefined ||
        this.$route.query.key === undefined ||
        this.$route.query.email === undefined
      ) {
        this.notFount = true;
      } else {
        this.storeThePassedData();
        this.notFount = false;
      }
    },
    async resetPassword() {
      if (this.oldPassword !== "") {
        this.validationText = "";

        const data = {
          action: "resetPasswordFromRecoveryPage",
          //action: this.resetData.action,
          key: this.resetData.key,
          email: this.resetData.email,
          newPassword: this.password,
        };

        const responce = await Mail.find(data).catch((error) => {
          console.log(error);
        });

        if (responce.status === 200) {
          this.passwordUpDated = true;

          const auth = getAuth();
          const newPassword = this.password;
          signInWithEmailAndPassword(
            auth,
            this.resetData.email,
            this.oldPassword,
          )
            .then((userCredential) => {
              updatePassword(userCredential.user, newPassword)
                .then(() => {
                  console.log("Update successful");
                })
                .catch((error) => {
                  console.log(error);
                });
            })
            .catch((error) => {
              console.log("Error signing in: ", error);
              this.validationText = "Old password is incorrect";
            });
        } else {
          this.validationText = "Please provide your old password";
        }
      }
    },
    storeThePassedData() {
      this.resetData = this.$route.query;
    },
  },
};
</script>
<style lang="scss" scoped></style>
